<rx-intuitive-bridge-diagram-footer
	[hasUnsavedChanges]="(hasUnsavedChanges$ | async) ?? false"
	[isReadOnly]="(isReadOnly$ | async) ?? false"
	(save)="onSave()"
	(revert)="onRevert()"
	(closed)="onClose()"
/>
